import React, { useState } from 'react';
import './Footer.css';
import logo from '../../assets/Okiri-logo-rmbg.png';
import { FaEnvelope } from 'react-icons/fa';
import pciDssBadge from '../../assets/pcidsscompliance-rmbg.png';

// Import Modal and legal content components
import Modal from '../Modal/Modal';
import TermsAndConditions from '../Legals/TermsAndConditions';
import PrivacyPolicy from '../Legals/PrivacyPolicy';
import RefundPolicy from '../Legals/RefundPolicy';

import pciImageModal from '../../assets/pci_CERTIFICATE_OF_COMPLIANCE-Okiri_Mobile_Mar_2025.png';

function Footer() {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalContent, setModalContent] = useState(null);

  const openModal = (type) => {
    // setModalOpen(true);
    switch(type) {
      // case 'terms':
      //   setModalTitle('Terms and Conditions');
      //   setModalContent(<TermsAndConditions />);
      //   break;
      case 'privacy':
        // setModalTitle('Privacy Policy');
        // setModalContent(<PrivacyPolicy />);
        // break;
        return window.open('https://okirimobile.com/privacy-policy', '_blank');
      // Uncomment the above lines and comment the below line when PrivacyPolicy component is ready

      case 'refund':
        // setModalTitle('Refund & Cancellation Policy');
        // setModalContent(<RefundPolicy />);
        // break;
        return window.open('https://okirimobile.com/refund-policy', '_blank');
      
      case 'data-policy':
        // setModalTitle('Data Usage Policy & Deletion Request');
        // setModalContent(<DataUsagePolicy />);
        // break; 
        return window.open('https://okirimobile.com/request-deletion', '_blank');
      case 'pci':
        setModalOpen(true);
        setModalTitle('PCI DSS Compliance');
        setModalContent(
          <div style={{ textAlign: 'center' }}>
            <img
              src={pciImageModal}
              alt="PCI DSS Compliance"
              style={{ maxWidth: '100%', height: 'auto' }}
            />
          </div>
        );
        break;
      default:
        setModalTitle('');
        setModalContent(null);
    }
  };

  const closeModal = () => {
    setModalOpen(false);
    setModalContent(null);
  };

  return (
    <>
      <footer className="footer" id='footer'>
        <div className="footer__columns">
          {/* First Column */}
          <div className="footer__column">
            <img src={logo} alt="OKIRI Logo" className="footer__logo" />
            <p className="footer__text">
              Transform Your Communication<br /> Experience with OKIRI
            </p>
            <p className="footer__address">
              23, COLLEGE ROAD , OGBA, IKEJA,<br /> LAGOS STATE, NIGERIA.
            </p>
            <div className="footer__contact">
              <FaEnvelope className="footer__icon" />
              <span>enquiries@okirimobile.com</span>
            </div>
          </div>

          {/* Second Column */}
          <div className="footer__column">
            <h4>App</h4>
            <ul>
              <li><a href="#features" className="footer__link">Features</a></li>
              <li><a href="#faqs" className="footer__link">FAQs</a></li>
              <li><a href="#pricing" className="footer__link">Plans</a></li>
            </ul>
          </div>

          {/* Third Column */}
          <div className="footer__column">
            <h4>Socials</h4>
            <ul>
              <li>Twitter</li>
              <li>Instagram</li>
              <li>Facebook</li>
            </ul>
          </div>

          {/* Fourth Column */}
          <div className="footer__column">
            <h4>Legal</h4>
            <ul>
              <li>
                <button
                  className="footer__link"
                  onClick={() => openModal('privacy')}
                >
                  Privacy Policy
                </button>
              </li>
              {/* <li>
                <button
                  className="footer__link"
                  onClick={() => openModal('terms')}
                >
                  Terms of Use
                </button>
              </li> */}
              <li>
                <button
                  className="footer__link"
                  onClick={() => openModal('refund')}
                >
                  Refund &amp; Cancellation Policy
                </button>
              </li>
                            <li>
                <button
                  className="footer__link"
                  onClick={() => openModal('data-policy')}
                >
                  Data Usage Policy &amp; Deletion Request
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer__bottom">
          <hr />
          <img
            src={pciDssBadge}
            alt="PCI DSS Compliant"
            className="footer__pci-badge"
            style={{ cursor: 'pointer' }}
            onClick={() => openModal('pci')}
          />
          <p>2025 OKIRI. All rights reserved.</p>
        </div>
      </footer>

      {/* Modal popup */}
      <Modal isOpen={modalOpen} onClose={closeModal} title={modalTitle}>
        {modalContent}
      </Modal>
    </>
  );
}

export default Footer;
